import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { Link } from "react-router-dom";

export default function HoriProjectCard({
    title="-", 
    desc="-", 
    emoji="banana", 
    first=false, 
    linkTo="/ProjectDetails", 
    state
}) {


    return(
        <>
            <Link to={linkTo} state={state}>
                <div
                    className={
                        `
                            border-[#8A8A8A]/[.30]
                            border-b
                            ${
                                first?"border-t":""
                            }
                            py-8
                            relative
                        `
                    }
                >
                    <h2
                        className="
                            text-3xl
                            font-medium
                            tracking-widest
                            text-home-text-light
                            dark:text-home-text-dark
                            text-center

                            flex
                            items-center
                            justify-center

                        "
                    >
                        <EmojiProvider data={emojiData}>
                            <Emoji className="inline" name={emoji} width={36}/>
                        </EmojiProvider>
                        &nbsp;{title}
                    </h2>
                    <span
                        className="
                            bottom-2
                            text-xs
                            text-home-text-grey
                            block
                            w-full
                            text-center
                            font-medium
                            absolute
                        "
                    >
                        {desc}
                    </span>
                </div>
            </Link>
        </>
    );
}